module.exports = __webpack_public_path__ + "static/img/100565.8098258a.png";